export const findAllowedFeature = (features, featureID) => {
  return features.find((feature) => feature.id === featureID);
};
